<template>
  <div>
    <ed-modal 
			:title="(formData.id == 0 ? 'Inserir 	Novo Email' : 'Editar Email')"
			:modal="showFormEdit" 
			:loadingSave="config.loading.save"
			:onSave="salvar"
			width="80%"
		>
			<div slot="modal-content">
        <ed-form 
          :data="formData" 
          :config="config" 
          :response="response" 
          :itens="emailItems"
        />

        <EdAlert title="Última Atualização" v-if="formData.usuario">
          <div slot="description">
            <b>Usuário:</b> {{formData.usuario.usuario}}<br>
            <b>Data:</b> {{toDate(formData.updated_at)}}
          </div>
        </EdAlert>
			</div>
    </ed-modal>

    <EdAlert title="Atenção" description="Aqui você pode cadastrar múltiplos emails para essa empresa especificando cada email por setores" type="warning"/>

    <TableView
      registerName="Inserir Novo Email"
      :onRegister="onRegister"
      :onEdit="onEdit"
      :onSearch="getEmail"
      :tableHead="tableHead"
      :tableData="tableData"
      :loadingTable="loadingTable"
      :pagination="pagination"
      :response="response"
    ></TableView>
  </div>
</template>

<script>
import TableView from "common/table";
import Rest from "common/rest";
import EdModal from 'common/modal'
import EdAlert from 'common/alert'
import EdForm from 'common/form'
import FormEmailItems from '../_form/meu-cadastro-email'

export default {
  name: "email",
  components: { TableView, EdAlert, EdModal, EdForm },
  mixins: [Rest],
  props: {
    empresa: {
      type: Object,
      default: null
    }
  },
  watch: {
    empresa() {
      this.getEmail();
      this.getFdt();
    }
  },
  data() {
    return {
      formData: {
        id: 0,
		    id_emp: null,
        id_usu:null,
        tipo:[],
        fdt: [],
        email: null,
        obs: null,
        ativo: 1
      },
      pagination: {},
      response: {},
      config:{
        tipo:[32],
        click:{
          fdt:this.getFdt
        },
        loading:{
          save:false,
          fdt:false,
        },
        list:{
          fdt:[]
        }
      },
      emailItems:[],
      tableHead: [
        {
          key: 'email',
					sortable: true,
					label: 'Email',
        },
        {
          key: 'setor',
					sortable: true,
					label: 'Setor',
        },
        {
          key: 'fdt',
					sortable: true,
					label: 'Frente de Trabalho',
        },
        {
          key: 'obs',
					sortable: true,
					label: 'Obs',
        }
      ],
      tableData: [],
      loadingTable: false,
      loadingSave: false,
      showFormEdit: false
    };
  },

  created() {},

  mounted: function() {
     this.emailItems = FormEmailItems;
    this.getEmail();
    this.getFdt();
  },

  methods: {
    onRegister: function() {
      this.formData = {
        id: 0,
		    id_emp: this.empresa.id,
        id_usu:null,
        tipo:[],
        fdt: [],
        email: null,
        obs: null,
        ativo: 1
      };
      this.showFormEdit = !this.showFormEdit;
    },

    onEdit: function(data) {

      var fdt = [], tipo = [];

      for (let j = 0; j < data.fdt.length; j++) {
        const element = data.fdt[j];
        fdt.push(
          data.fdt[j].id
        )
      }

      for (let j = 0; j < data.tipo.length; j++) {
        const element = data.fdt[j];
        tipo.push(
          data.tipo[j].id
        )
      }

      this.formData = {
          id: data.id,
          id_usu: data.usuario.id_usu,
          id_emp: this.empresa.id,
          obs: data.obs,
          tipo: tipo,
          fdt: fdt,
          email: data.email,
          usuario:data.usuario,
          updated_at: data.updated_at,
          ativo: data.ativo
      };
      this.showFormEdit = !this.showFormEdit;
    },

     getFdt(){

      if(!this.empresa || !this.empresa.id)return;

      this.config.loading.fdt = true;
      this.config.list.fdt = [];

      this.get('pcmso/fdt',{pagination:100}).then((result)=>{

          result = result[0];

          this.config.loading.fdt = false;

          if(result.status == 200){
            this.config.list.fdt = result.data.data;
          }

      });
    },

    getEmail: function(_search, _page, _pagination) {
      
      this.loadingTable = true;
	
      this.get("/email/0", {search: _search,page: _page,pagination: _pagination}).then(result => {
        result = result[0];
          if (result.status == 200) {
            var data = result.data.data,
              tableData = [],
              pagination = result.data;

            for (var i = 0; i < data.length; i++) {

              var fdt = [], tipo = [];

              for (let j = 0; j < data[i].fdt.length; j++) {
                const element = data[i].fdt[j];
                fdt.push(
                  element.pcmso+' ('+element.descricao+')'
                )
              }

              for (let j = 0; j < data[i].tipo.length; j++) {
                const element = data[i].tipo[j];
                tipo.push(
                  element.descricao
                )
              }

              var item = {
                nome: data[i].nome,
                email: data[i].email.replace(';','<br>'),
                obs: (data[i].obs ? data[i].obs : '---'),
                fdt: (fdt.length>0 ? fdt.join('<br>') : '---'),
                setor: (tipo.length>0 ? tipo.join('<br>') : '---'),
                ativo: (data[i].ativo == 1 ? 'Sim' : 'Não'),
                _data: data[i],
                options: {
                  style:'color:'+(data[i].ativo == 1 ? 'green' : 'red'),
                  title:(data[i].ativo == 1 ? '' : 'Email inativo. Clique para atualizar.')
                },
                buttons: []
              };
              tableData.push(item);
            }

            this.pagination = pagination;
            this.tableData = tableData;
            this.loadingTable = false;
          }
      });
    },

    salvar() {
      this.config.loading.save = true;
      this.response = {};

      this.post("/email/0/editar",this.formData).then(result => {
        result = result[0];

        this.config.loading.save = false;
        this.response = result;

        if (result.status == 200) {
          this.edMsg('Email salvo com sucesso!');
          this.showFormEdit = !this.showFormEdit;
          this.getEmail();
        } 

      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// index.vue?4c532442